const iosFriendly = x => x.replace(/([+-]\d{2})(\d{2})$/, "$1:$2");

export const getPrismicTime = value => {
  return Date.parse(iosFriendly(value));
};

export const getPrismicDate = (value = "") => {
  return new Date(value.replace(/-/g, "/").replace("T", " "));
};
